import axios, { Axios, AxiosRequestConfig } from "axios";
import { strings } from "../constants/Strings";
// import { errorNotification } from "../Modules/Shared/Notifications/Notifications";
import { clearCookie, getCookie } from "./cookieUtils";
// import { errorNotification } from "../base/Notifications/Notifications";
import { ACCESS_TOKEN } from "./enums/misc";
import { LOGIN } from "../constants/RouteUrls";

const instance = axios.create({
  baseURL: strings.base_url,
});

instance.interceptors.request.use(
  (config: any) => {
    const accessToken = getCookie(ACCESS_TOKEN);
    if (accessToken) {
      config.headers["Authorization"] = `${accessToken}`;
    }
    // if (config.headers["Content-Type"]) {
    //   config.headers["Content-Type"] = config.headers["Content-Type"];
    // }
    config.headers["lang"] = "en";
    return config;
  },
  (error: any) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: {
    response: { status: number; data: { message: any } };
    config: { url: string };
  }) => {
    console.log(error);
    if (error.response.status === 401 && error.config.url !== LOGIN) {
      clearCookie(ACCESS_TOKEN);
      window.location.href = "/";
    } else {
      if (error?.response?.data?.message) {
        // errorNotification(error?.response?.data?.message);
      }
      return Promise.reject(error);
    }
  }
);

export default instance;

export const mediaUploadInstance = axios.create({
  baseURL: strings.base_url,
});

mediaUploadInstance.interceptors.request.use((config) => {
  const token = getCookie(ACCESS_TOKEN);
  if (token) {
    config.headers['Authorization'] = token;
  }
  config.headers['lang'] = 'en';
  return config;
});

export const messageServiceInstance = axios.create({
  baseURL: strings.message_service_url,
});

messageServiceInstance.interceptors.request.use((config) => {
  const token = getCookie(ACCESS_TOKEN);
  if (token) {
    config.headers['Authorization'] = `${token}`;
  }
  return config;
},
  (error: any) => Promise.reject(error)
);

messageServiceInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: {
    response: { status: number; data: { message: any } };
    config: { url: string };
  }) => {
    console.log(error);
    if (error.response?.status === 401 && error.config?.url !== LOGIN) {
      clearCookie(ACCESS_TOKEN);
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const functionBasedInstance = axios.create({
  baseURL: strings.function_based_url,
});

functionBasedInstance.interceptors.request.use((config) => {
  const token = getCookie(ACCESS_TOKEN);
  if (token) {
    config.headers['Authorization'] = `${token}`;
  }
  return config;
},
  (error: any) => Promise.reject(error)
);

functionBasedInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: {
    response: { status: number; data: { message: any } };
    config: { url: string };
  }) => {
    console.log(error);
    return Promise.reject(error);
  }
);
